import { useEffect, useState } from 'react';
import { PopoverModelWrapper } from '../../components/modal/modal.styled';
import Heading from '../../components/typography';
import { ActionButton } from '../../components/vertical-dot/popper';
import { TableBodyCellColumn } from '../style/table.styled';
import { COLORS } from '../style/color';

export const VendorFeatureSetHeader = ({
  actions,
  tableActions,
}: {
  actions: any;
  tableActions: any;
}): any[] => {
  const newActions = [
    ...(actions || []),
    {
      accessor: 'actions',
      width: 20,
      sortable: false,
      isSubHeader: false,
      renderCell: true,
      Cell: ({ row }: any) => {
        return (
          <td>
            <ActionButton
              actions={tableActions}
              id={row.original.id}
              rowData={row.original}
              counter={parseInt(row?.id)}
            />
          </td>
        );
      },
    },
  ];

  return newActions;
  return [
    {
      Header: 'Name',
      accessor: 'name',
      width: 200,
      Cell: ({ row }: any) => (
        <TableBodyCellColumn>
          {(row.original.name as boolean) ? row.original.name : '-'}
        </TableBodyCellColumn>
      ),
    },
    {
      Header: 'Description',
      accessor: 'description',
      width: 150,
      sortable: false,
      Cell: ({ row }: any) => {
        return (
          <TableBodyCellColumn className=''>
            <div className='cellTitle '>
              {(row.original.description as boolean) ? row.original.description : '-'}
            </div>
          </TableBodyCellColumn>
        );
      },
    },
    {
      Header: '',
      accessor: 'actions',
      width: 20,
      sortable: false,
      Cell: ({ row }: any) => (
        <ActionButton
          actions={actions}
          id={row.original.id}
          rowData={row.original}
          counter={parseInt(row?.id)}
        />
      ),
    },
  ];
};
